import ButtonLink from '@/components/base/ButtonLink';

const managedAreas = [
  { icon: 'ri-building-2-line', label: 'Buildings & systems' },
  { icon: 'ri-plant-line', label: 'Grounds & amenities' },
  { icon: 'ri-chat-3-line', label: 'Resident requests' },
  { icon: 'ri-file-list-3-line', label: 'Records & budgets' },
];

export default function IntroContent() {
  return (
    <div>
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-6">
        <div className="lg:col-span-6">
          <p className="mb-3 font-label text-[12px] font-semibold uppercase tracking-[0.14em] text-accent-500 md:text-[13px]">What we do</p>
          <h2 id="intro-heading" className="font-heading text-[30px] font-semibold leading-[1.1] tracking-[-0.015em] text-foreground-950 md:text-[38px] lg:text-[48px]">
            Good management makes everyday living easier.
          </h2>
        </div>
        <div className="space-y-4 lg:col-span-5 lg:col-start-8 lg:pt-9">
          <p className="text-[16px] leading-[1.62] text-foreground-700 md:text-[17px]">
            We look after the shared parts of residential communities: the buildings, the grounds, the amenities and the routines that keep them working. Boards and owners get a steady operating partner; residents get a clear place to turn when something needs attention.
          </p>
          <p className="text-[16px] leading-[1.62] text-foreground-700 md:text-[17px]">
            Our work is practical and ongoing. Vendors are scheduled, inspections are kept, requests are answered and records stay organized, so decisions can be made with current information.
          </p>
          <ButtonLink to="/services" variant="text">See how we manage communities</ButtonLink>
        </div>
      </div>
      <ul className="mt-12 grid grid-cols-2 border-t border-background-300 lg:mt-16 lg:grid-cols-4">
        {managedAreas.map((a) => (
          <li key={a.label} className="flex items-center gap-3 border-b border-background-200 py-5 pr-3 lg:border-b-0">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-50 text-[18px] text-accent-500">
              <i className={a.icon} aria-hidden="true"></i>
            </span>
            <span className="text-[15px] font-medium text-foreground-950 md:text-[16px]">{a.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}